import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  StockOptions = 'StockOptions',
}

export const queryKeys = {
  stockOptions: (clientId: string) => [QueryFeature.Profile, QueryKey.StockOptions, clientId],
};
